import React, { useState, useEffect } from 'react'
import { AiOutlineDown } from "@react-icons/all-files/ai/AiOutlineDown";
import { AiOutlineRight } from "@react-icons/all-files/ai/AiOutlineRight";
import Clickable from './Clickable';

const Collapsible = ({ name, children, closed, className, onClick }) => {
  let [open, setOpen] = useState(true)
//console.log(closed)
  useEffect(()=>  {
    if(closed) setOpen(false)
  },[closed])

  if (!open) return <div className={`collapsible ${className}`} >
    <div className="header" >
      
      <Clickable name={name} onClick={() => setOpen(true)} > <AiOutlineRight /></Clickable>
      <strong onClick={onClick}>{name}</strong>
    </div>
  </div>


  return <div className={`collapsible ${className}`}>
    <div className="header">
      <Clickable onClick={() => setOpen(false)} > <AiOutlineDown /></Clickable>
     
      <strong onClick={onClick}>{name}</strong>
    </div>
    {children}
  </div>
}

export default Collapsible